import { IntegrationDefinition } from "@/types/breeze/Integration";

export type ConfigShape = "api_key" | "oauth";

export function getConfigShape(def: IntegrationDefinition): ConfigShape {
  return def.auth_type === "ApiKey" ? "api_key" : "oauth";
}

// Fallback for backends that pre-date the `supports_native_signin` flag.
// Authoritative source is the field on the DTO itself.
export const KNOWN_NATIVE_PROVIDERS = new Set(["apple", "google", "linkedin"]);

export function supportsNative(def: IntegrationDefinition): boolean {
  return typeof def.supports_native_signin === "boolean"
    ? def.supports_native_signin
    : KNOWN_NATIVE_PROVIDERS.has(def.provider);
}

export function getDialogCopy(def: IntegrationDefinition): {
  title: string;
  description: string;
} {
  const shape = getConfigShape(def);
  if (shape === "api_key") {
    return {
      title: `Connect ${def.display_name}`,
      description: `Provide your ${def.display_name} API key. We store it encrypted and never display it again after saving.`,
    };
  }

  if (def.can_social_sign_in && supportsNative(def)) {
    return {
      title: `Configure ${def.display_name} sign-in`,
      description:
        "Enable native (mobile SDK), web (browser redirect), or both. Each flow is configured independently — you can save with just one filled in.",
    };
  }

  if (def.can_social_sign_in) {
    return {
      title: `Configure ${def.display_name} sign-in`,
      description: "Configure the web sign-in OAuth credentials.",
    };
  }

  return {
    title: `Configure ${def.display_name}`,
    description: "OAuth credentials for the workflow integration.",
  };
}
